// extracted by mini-css-extract-plugin
export default {"shadow":"layout_shadow__SI46H","skeleton":"layout_skeleton__+Vl4R","loading":"layout_loading__96IGW"};